import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './faq-entry.magic.css.js';
import script from './faq-entry.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('magic-ui-accordion',{staticClass:"accordion",attrs:{"wide":"","elevation":"2","no-animation":"","part":"accordion","data-v-test-id":"faq-entry-accordion","initially-visible":_vm.initiallyVisible},on:{"toggle":_vm.onToggle}},[_c('magic-ui-text',{staticClass:"question",attrs:{"slot":"toggle","tag":"h5","part":"question","data-v-test-id":"faq-entry-question","content":_vm.question},slot:"toggle"}),_vm._v(" "),_c('magic-ui-text',{staticClass:"answer",attrs:{"slot":"content","part":"answer","data-v-test-id":"faq-entry-answer","content":_vm.answerHtml},slot:"content"})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5f8336ea_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5f8336ea";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
